import React, { useState } from "react"
import { IDetail, IFormEditDetail } from "./interface"
import * as Yup from "yup"
import Row from "../Row";
import { Field, Form, Formik } from "formik";
import Input from "../Input";
import Select from "../Select";
import Button from "../Button";
import { Container, Legend } from "./style";
import { updateDetails } from "../../hooks/updateDetail";
import { errorHandlerApi } from "../../hooks/errorHandlerApi";
import { staticMessagesError } from "../../helpers/staticMessagesError";
import { toastCreate } from "../../utils/notifications/toast";
import { TIME_INFO } from "../../utils/notifications/time";

const FormEditDetails = ({
    detail,
    selectedProduct,
    formState,
    setRefresh
}: IFormEditDetail
): React.ReactElement => {

    const validationDetails = Yup.object().shape({
        details: Yup.string().required(),
        status: Yup.string().required(),
        amount: Yup.string().nullable()
    })
    const active = 0
    const inactive = 1

    return (
        <Formik
            initialValues={{
                details: "",
                amount: "",
                status: detail.status,
            }}
            validationSchema={validationDetails}
            onSubmit={async (values,{resetForm}) => {
                const { isError, block } = await updateDetails(
                    selectedProduct, 
                    values,
                    "editDetail"
                )
                
                if(!isError) {
                    formState("close")
                    resetForm()
                    setRefresh(true)
                }

                else {
                    errorHandlerApi(
                        block, 
                        staticMessagesError.EDIT_DETAIL,
                        () => {},
                        "editDetail"
                    )
                }
            }}
        >
            {({
                initialValues, 
                errors, 
                handleChange, 
                dirty, 
                isValid, 
                touched
            }) => {
                initialValues.details = detail.details,
                initialValues.amount = detail.amount
                    .slice(0,-2) + "," + detail.amount.slice(-2)

                return (
                    <Container>
                        <Form >
                            <Row>
                                <fieldset>
                                    <Legend>{ detail.details }</Legend>
                                    <Field 
                                        id="details" 
                                        name="details" 
                                        className="inputCustom" 
                                        placeholder="Detalhe do produto" 
                                        isError={touched.details && errors.details}
                                        as={Input}
                                    />
                                    
                                    <Field
                                        id="status" 
                                        name="status"
                                        handleChange={handleChange}
                                        value={detail.status}
                                        isError={touched.status && errors.status}
                                        as={Select}
                                    >
                                        <option value={active} >Ativo</option>
                                        <option value={inactive} >Inativo</option>
                                    </Field>

                                    <Field 
                                        id="amount" 
                                        name="amount"
                                        type="text"
                                        className="inputCustom" 
                                        placeholder="Valor" 
                                        isError={touched.amount && errors.amount}
                                        as={Input}
                                    />
                                    
                                </fieldset>
                            </Row>
                            <Row>
                                    <Button 
                                        disabled={ !(dirty && isValid)}
                                        onClick={() => {
                                            toastCreate(
                                                "editDetail",
                                                "info",
                                                TIME_INFO,
                                                "Processando..."
                                            )
                                        }}
                                        type="submit">
                                            Editar detalhe
                                    </Button>
                            </Row>
                        </Form>
                    </Container>
                )
            }}
        </Formik>
    )
}

export default FormEditDetails